<template>
    <CommonBox :title="titles[updateType]" @close="$emit('close')" @submit="submit">
        <el-form ref="form" label-width="190px" :model="initForm" :rules="rules">
            <el-form-item label="First Name" prop="FirstName">
                <el-input v-model="initForm.FirstName"></el-input>
            </el-form-item>

            <el-form-item label="Last Name">
                <el-input v-model="initForm.LastName"></el-input>
            </el-form-item>

            <span v-if="this.updateType === 'add'">
                <el-form-item label="Email" prop="Email">
                    <el-input v-model="initForm.Email"></el-input>
                </el-form-item> 

            <el-form-item label="Password" prop="Password">
                <el-input v-model="initForm.Password"></el-input>
            </el-form-item>
            <br>
            <br>

            <el-form-item label="Confirm Password" prop="ConfirmPassword">
                <el-input v-model="initForm.ConfirmPassword"></el-input>
            </el-form-item>
            </span>
    

            <span v-if="this.updateType === 'edit'">
                <el-form-item label="Email" prop="Email">
                    <el-input v-model="initForm.Email" :disabled="true"></el-input>
                </el-form-item> 
            </span>
        
            <span   v-if="this.type === '2'">
                <el-form-item label="Type" prop="Type">
                <el-select v-model="initForm.Type" >
                    <el-option
                        v-for="item in types1"
                        :key="item.key"
                        :label="item.value"
                        :value="item.key">
                    </el-option>
                </el-select>
                </el-form-item>
            </span>
               
               <span   v-if="this.type === '1'">
               <el-form-item label="Type" prop="Type">
                <el-select v-model="initForm.Type" >
                    <el-option
                        v-for="item in types0"
                        :key="item.key"
                        :label="item.value"
                        :value="item.key">
                    </el-option>
                </el-select>
            </el-form-item>
              </span>

             
       
        </el-form>
    </CommonBox>
</template>

<script>
import CommonBox from "@/components/common/CommonBox.vue";
import { types0 } from "@/utils/type0.data.js";
import { types1 } from "@/utils/type1.data.js";
export default {
    components:{
        CommonBox
    },
    props:{
        updateType:{},
        type:{},
        initForm:{}
    },
    data () {
        return {
            titles:{
                add:"Add Account",
                edit:"Edit Account"
            },
            rules:{
                FirstName:[{required: true, message: 'Please enter a first name', trigger: 'blur'}],
                /* LastName:[{required: true, message: 'Please enter a lastName', trigger: 'blur'}], */
                Email:[{ required: true, message: 'Please input the email address', trigger: 'blur' },
                    { type: 'email', message: 'Please input the correct email address', trigger: ['blur', 'change'] }],
                Password:[{required: true, message: 'Please enter a correct password', trigger: 'blur'},
                    { pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{11,}$/, 
                        message: 'The password must be at least 11 characters long and contain at least three of the four types: uppercase letters, lowercase letters, special characters and digits. ' }
                ],
                ConfirmPassword:[{required: true, message: 'Please enter a correct password', trigger: 'blur'},
                    { pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{11,}$/, 
                        message: 'Two passwords are inconsistent.' }
                ],
                Type:[{required: true, message: 'Please select a user type', trigger: 'blur'}]
            },
            types0,
            types1
        };
    },
    mounted () {
    },
    methods:{
        submit () {
            this.$refs.form.validate((valid) => {
                if(!valid) return false;
                let from = Object.assign({},this.initForm);
                let methods = this.updateType === 'add' ? 'post' : 'put';
                let url = this.updateType === 'add' ? 'addAccount' : 'editAccount';
                this.$http[methods](url,from,(data)=>{
                    this.$baseNotice.message(data.msg);
                    this.$emit('close');
                    this.$emit('update');
                });
            });
        }
    }
};
</script>
